import React from "react";
import SpotUpper from "../../component/spot";

export function Spot() {
  return <SpotUpper />;
}
